<template>
  <!-- TODO: 中央寄せ用に置いてるdivなので後ほど削除 -->
  <div class="select-area">
    <div
      class="c-select"
      :class="{
        up_down_icon: up_down_icon,
        learge: learge,
        middle: middle,
      }"
      >
      <select class="c-select__item" :class="{round}" name="" id="">
        <option value="">下限なし</option>
        <option value="">1</option>
        <option value="">2</option>
        <option value="">3</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonSelect',
  props: ['learge', 'middle', 'up_down_icon', 'round', 'default'],
  data() {
    return {};
  },
};
</script>

<style lang='scss' scoped>
@charset 'UTF-8';
.select-area {
  text-align: center;
}

.c-select {
  display: inline-block;
  width: 100%;
  max-width: 120px;
  font-size: 14px;
  position:relative;

  &__item {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px;
    padding-right: 30px;
    border-radius: 10px;
    border: 1px solid #666;
    appearance: none;
    z-index: 1;
    cursor: pointer;
  }
  &:after {
    position: absolute;
    top: calc(50% - 12px);
    right: 4px;
    content: "";
    display: inline-block;
    width: 25px;
    height: 24px;
    background-image: url(/static/img/icon-sort-3.png);
    background-size: cover;
    z-index: 10;
    pointer-events: none;
  }
  &.up_down_icon:after {
    background-image: url(/static/img/icon-sort-4-s.png);
    background-size: cover;
    pointer-events: none;
  }
  &.learge {
    max-width: 240px;

    .c-select__item {
      padding: 12px 20px;
      padding-right: 30px;
    }
    &:after {
      right: 12px;
      pointer-events: none;
    }
  }
  &.middle {
    max-width: 200px;

    .c-select__item {
      padding: 12px 20px;
      padding-right: 30px;
    }
    &:after {
      right: 12px;
      pointer-events: none;
    }
  }
}

.round {
  border-radius: 20px;
}
</style>
